import { useEffect } from "react";

// Loads Microsoft Clarity only after the user gives consent (via the cookie
// banner setting `gm_consent=1` in localStorage). Runs once per page load.
export default function ClarityLoader() {
  useEffect(() => {
    const id = process.env.REACT_APP_CLARITY_ID;
    if (!id) return;

    const load = () => {
      if (window.__clarityLoaded) return;
      try {
        if (localStorage.getItem("gm_consent") !== "1") return;
      } catch (_) {
        return;
      }
      window.__clarityLoaded = true;
      (function (c, l, a, r, i, t, y) {
        c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments); };
        t = l.createElement(r); t.async = 1; t.src = "https://www.clarity.ms/tag/" + i;
        y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y);
      })(window, document, "clarity", "script", id);
    };

    // Try immediately (returning users who already consented)
    load();

    // Also listen for the consent event the banner fires
    window.addEventListener("gm-consent-accepted", load);
    return () => window.removeEventListener("gm-consent-accepted", load);
  }, []);

  return null;
}
